import { getAxiosInstance } from "../ApiConfig";

async function FetchAllOutReachQueueList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllOutreachQueueByApprovarId`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalMyList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCreatedOutreach`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllApprovalSharedList() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedOutreach`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByOutreachId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ruleSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createOutreach`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ruleUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateOutreach/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function OutreachLeadUpdate(payload, outReachId, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/addLeadToOutreach/${outReachId}/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function OutreachQueueUpdate(payload, outReachId) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateOutreachQueue/${outReachId}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteRuleId(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteOutreach/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function checkcronjobqueue(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/checkOutreachLeadMail/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function checkLeadqueue(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/checkOutreachQueue/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    ruleDetailData,
    ruleSave,
    ruleUpdate,
    deleteRuleId,
    FetchAllOutReachQueueList,
    FetchAllApprovalMyList,
    FetchAllApprovalSharedList,
    OutreachLeadUpdate,
    OutreachQueueUpdate,
    checkLeadqueue,
    checkcronjobqueue,
}